import { ApolloQueryResult } from "@apollo/client";
import {
  CompetencyMapsQuery,
  Exact,
  InputMaybe,
  ListCompetencyMapFilterInput,
  PlatformCompetencyMapListOrderInput,
  Scalars,
} from "@generated/graphql";

export enum CreationType {
  CONSTRUCTOR,
  TEMPLATE,
  JSON,
  DOCUMENTS,
  VACANCY,
}

export type RefetchCompetencyMaps = (
  variables?:
    | Partial<
        Exact<{
          filter?: InputMaybe<ListCompetencyMapFilterInput>;
          limit: Scalars["Float"]["input"];
          page: Scalars["Float"]["input"];
          order: PlatformCompetencyMapListOrderInput;
        }>
      >
    | undefined
) => Promise<ApolloQueryResult<CompetencyMapsQuery>>;
